/*******************************************************************************
 * Copyright (c) 2024 Belltane LLC
 *
 * All rights reserved.
 *
 * Contributors:
 *   Amina Rais - Initial implementation
 *
 * Version: 1.0.0
 *
 *******************************************************************************/

import React from 'react'
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';

import Container from '@mui/material/Container';
import PageSubHeader from '../../../components/Layout/PageSubHeader'



const DeletemePage = () => {
    const { t } = useTranslation()
    const { classes } = useStyles();

    return (
        <>
            <PageSubHeader location={t('titles:deleteme')} />
            <Container className={classes.cardGrid} maxWidth="md">
                <Grid container maxwidth="sm" justify="center" className={classes.pageContainer} spacing={5} alignItems="stretch" >


                    <section>
                        <Typography variant="h3" className={classes.title}>Request Account Deletion</Typography>
                        <p> <Typography variant="h5" className={classes.title}>If you would like to delete your account, please follow the steps below:</Typography></p>
                        <ol>
                            <li> <Typography variant="h5" className={classes.title}>Send an email to <a href="mailto:info@pictitude.com">info@pictitude.com</a> with your account deletion request.</Typography></li>
                            <li>                        <Typography variant="h5" className={classes.title}>
                                Include your account details (e.g., username, birthdate, email address) for verification purposes.</Typography></li>
                            <li>                        <Typography variant="h5" className={classes.title}>
                                Our support team will process your request as soon as possible.</Typography></li>
                        </ol>
                    </section>


                    <section>
                        <Typography variant="h3" className={classes.title}>Data Retention</Typography>
                        <Typography variant="h5" className={classes.title}>
                            Upon account deletion, the following types of data will be deleted:</Typography>
                        <ul>
                            <li>                        <Typography variant="h5" className={classes.title}>
                                Personal information provided during account registration.</Typography></li>
                            <li>                        <Typography variant="h5" className={classes.title}>
                                User-generated content, including pet profiles, posts, comments, and any other personal information. This action is irreversible, and the data cannot be recovered.</Typography></li>
                        </ul>
                        <Typography variant="h5" className={classes.title}>
                            No data associated with your account will be retained after deletion.</Typography>
                    </section>
                </Grid></Container>
        </>
    )
}
const useStyles = makeStyles({ "name": { DeletemePage } })((theme) => ({

    pageContainer: {
        backgroundColor: '#dce7eb',
        padding: '1.5%',

    },

    card: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },



    sectionTitleBorder: {
        width: '100px',
        height: '2px',
        marginRight: 'auto',
        marginLeft: 'auto',
        backgroundColor: '#fb743e',
        marginBottom: '30px',

    },


    title: {
        paddingTop: '20px'
    }
}));
export default DeletemePage
